// http 反转义

function HTMLDecode(text) {
  var temp = document.createElement('div')
  temp.innerHTML = text
  var output = temp.innerText
  if (output === true) {
    return true
  } else {
    return false
  }
}

export default HTMLDecode



// WEBPACK FOOTER //
// ./src/common/HTMLDecode.js